import { useIntl } from 'react-intl';

import {
	ProductGrid,
	useProductData,
	ProductCategory,
	ProductItem,
	categories,
} from '../product-subnav';

import { MobileNavTitle } from './mobile-nav-card';

export const MobileNavProductDevelopers = () => {
	const intl = useIntl();

	const { productsByTag } = useProductData();
	const developersProducts = productsByTag[ProductCategory.Developers] || [];

	return (
		<div>
			<MobileNavTitle title={intl.formatMessage(categories[ProductCategory.Developers].title)} />
			<ProductGrid>
				{developersProducts.map((product) => (
					<ProductItem key={product.id} {...product} />
				))}
			</ProductGrid>
		</div>
	);
};
